import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {PropertyUnitPeriod} from '../models/property.unit.period.interface';

@Injectable()
export class PeriodFromParentRouteResolver {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): PropertyUnitPeriod {
    return route?.parent?.data?.period as PropertyUnitPeriod;
  }
}
